export function makePropSrOnly(srOnly, srOnlyProp, sourceProp) {
    if (srOnly !== true) {
        return sourceProp;
    }
    return srOnlyProp;
}
